import styled from "styled-components";

export const SelectGroup = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: ${props => props.theme.minWidth}) {
        & > *:not(:last-child) {
            margin-right: 1rem;
        }
    }
    @media (max-width: ${props => props.theme.maxWidth}) {
        flex-direction: column;

        & > * {
            margin: 0.25rem 0;
        }
    }
`;
